import { render, staticRenderFns } from "./ChangeIdentityDetails.vue?vue&type=template&id=f9c90002&"
import script from "./ChangeIdentityDetails.vue?vue&type=script&lang=js&"
export * from "./ChangeIdentityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports